import { actionTypes } from "./employeeActionTypes";
import {
  SET_SEARCH_TEXT,
  SET_LOADER,
  SET_ENABLE
} from "./EmployeeSearch/EmployeeSearchActionTypes";
import * as State from "./InitialState/";

export default function employeeReducer(state = State.INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.ADD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        saving: false,
        errors: {},
        employeeRecord: [...state.employeeRecord, action.employee]
      };
    case actionTypes.SET_EMPLOYEE_ID:
      return { ...state, empId: action.id };
    case SET_SEARCH_TEXT:
      return {
        ...state,
        employeeRecord: action.payload.data,
        searchText: action.searchText
      };
    case SET_LOADER:
      return {
        ...state,
        loading: action.isLoading
      };
    case SET_ENABLE:
      return {
        ...state,
        searchEnable: action.searchEnable
      };
    case actionTypes.SHOW_ERROR:
      return { ...state, isError: action.isShow, message: action.payload };
    case actionTypes.SHOW_EMPLOYEE_LIST:
      return { ...state, employeeRecord: action.payload.data };
    case actionTypes.SHOW_EMPLOYEE_DETAILS:
      return { ...state, employeeDetailView: true, employeesListView: false };
    case actionTypes.SET_EDUCAITON_LIST:
      return { ...state, educationArray: action.data };
    case actionTypes.SET_FAMILY_LIST:
      return { ...state, familyArray: action.data };
    case actionTypes.SET_SKILL_LIST:
      return { ...state, skillArray: action.data };
    case actionTypes.SET_WORK_HISTORY_LIST:
      return { ...state, workHistoryArray: action.data };
    case actionTypes.DELETE_EDUCATION_ARRAY:
      return {
        ...state,
        educationArray: [
          ...state.educationArray.filter(
            data => data.DegreeName !== action.DegreeName
          )
        ]
      };
    case actionTypes.DELETE_FAMILY_ARRAY:
      return {
        ...state,
        familyArray: [
          ...state.familyArray.filter(data => data.Id !== action.Id)
        ]
      };
    case actionTypes.DELETE_SKILL_ARRAY:
      return {
        ...state,
        skillArray: [...state.skillArray.filter(data => data.Id !== action.Id)]
      };
    case actionTypes.DELETE_WORK_ARRAY:
      return {
        ...state,
        workHistoryArray: [
          ...state.workHistoryArray.filter(data => data.ID !== action.Id)
        ]
      };
    case actionTypes.SET_EMPLOYEE_DETAILS:
      return {
        ...state,
        ImageUrl: action.payload.ImageUrl,
        employeeDetail:action.payload.employeeDetail,
        personalInfo: action.payload.personalInfo,
        otherInfo: action.payload.otherInfo,
        contactInfo: action.payload.contactInfo,
        educationArray: action.payload.educationArray,
        familyArray: action.payload.familyArray,
        skillArray: action.payload.skillArray,
        workHistoryArray: action.payload.workHistoryArray,
        empId: action.payload.empId
      };
    case actionTypes.CLEAR_EMPLOYEE_DETAILS:
      return {
        ...state,
        personalInfo: { ...State.INITIAL_STATE.personalInfo },
        employeeDetail:{...State.INITIAL_STATE.employeeDetail},
        otherInfo: { ...State.INITIAL_STATE.otherInfo },
        contactInfo: { ...State.INITIAL_STATE.contactInfo },
        educationInfo: { ...State.INITIAL_STATE.educationInfo },
        educationArray: [],
        familyDetail: { ...State.INITIAL_STATE.familyDetail },
        familyArray: [],
        skillArray: [],
        workHistoryInfo: { ...State.INITIAL_STATE.workHistoryInfo },
        workHistoryArray: [],
        skillInfo: { ...State.INITIAL_STATE.skillInfo },
        empId: ""
      };
    case actionTypes.ADD_BTN:
      return {
        ...state,
        addNewDepartment: true,
        departmentsList: false,
        title: "Add New Department"
      };
    case actionTypes.EDIT_BTN:
      return {
        ...state,
        addNewDepartment: true,
        departmentsList: false,
        title: "Edit Department"
      };
    case actionTypes.CANCEL_BTN:
      return {
        ...state,
        addNewDepartment: false,
        departmentsList: true,
        title: ""
      };
    case actionTypes.CANCEL_BTN_EMPLOYEE:
      return {
        ...state,
        addNewEmployeeView: false,
        employeesListView: true,
        employeeDetailView: false
      };

    case actionTypes.ADD_BTN_EMPLOYEE:
      return {
        ...state,
        text: "Add New Employee",
        personalInfo: { ...State.INITIAL_STATE.personalInfo },
        employeeDetail: { ...State.INITIAL_STATE.employeeDetail },
        otherInfo: { ...State.INITIAL_STATE.otherInfo },
        contactInfo: { ...State.INITIAL_STATE.contactInfo },
        educationInfo: { ...State.INITIAL_STATE.educationInfo },
        educationArray: [],
        familyDetail: { ...State.INITIAL_STATE.familyDetail },
        familyArray: [],
        skillArray: [],
        workHistoryInfo: { ...State.INITIAL_STATE.workHistoryInfo },
        workHistoryArray: [],
        skillInfo: { ...State.INITIAL_STATE.skillInfo },
        empId: 0,
        workHistoryInfoCheck: false,
        skillInfoCheck: false,
        employeeDetailInfoCheck:false,
        familyDetailCheck: false,
        educationInfoCheck: false,
        contactInfoCheck: false,
        personalInfoCheck: false,
        addNewEmployeeView: true,
        employeesListView: false,
        employeeDetailView: false,
        isEditView: action.isEdit,
        personalInfoErrors: { ...State.INITIAL_STATE.personalInfoErrors },
        employeeDetailErrors: { ...State.INITIAL_STATE.employeeDetailErrors },
        contactInfoErrors: { ...State.INITIAL_STATE.contactInfoErrors },
        educationInfoErrors: { ...State.INITIAL_STATE.educationInfoErrors },
        familyDetailErrors: { ...State.INITIAL_STATE.familyDetailErrors },
        skillInfoErrors: { ...State.INITIAL_STATE.skillInfoErrors },
        workHistoryInfoErrors: { ...State.INITIAL_STATE.workHistoryInfoErrors },
        otherInfoErrors: { ...State.INITIAL_STATE.otherInfoErrors }
      };
    case actionTypes.EDIT_EMPLOYEE_DETAILS:
      return {
        ...state,
        text: "Edit Employee",
        addNewEmployeeView: true,
        employeesListView: false,
        employeeDetailView: false,
        isEditView: action.isEdit,
        personalInfoErrors: { ...State.INITIAL_STATE.personalInfoErrors },
        employeeDetailErrors: { ...State.INITIAL_STATE.employeeDetailErrors },
        contactInfoErrors: { ...State.INITIAL_STATE.contactInfoErrors },
        educationInfoErrors: { ...State.INITIAL_STATE.educationInfoErrors },
        familyDetailErrors: { ...State.INITIAL_STATE.familyDetailErrors },
        skillInfoErrors: { ...State.INITIAL_STATE.skillInfoErrors },
        workHistoryInfoErrors: { ...State.INITIAL_STATE.workHistoryInfoErrors },
        otherInfoErrors: { ...State.INITIAL_STATE.otherInfoErrors }
      };
    case actionTypes.CHECK_PERSONAL_INFO_CHANGE:
      return {
        ...state,
        personalInfoCheck: true,
        employeeDetailInfoCheck:false,
        contactInfoCheck: false,
        educationInfoCheck: false,
        familyDetailCheck: false,
        skillInfoCheck: false,
        workHistoryInfoCheck: false
      };
      case actionTypes.CHECK_EMP_DETAIL_CHANGE:
      return {
        ...state,
        personalInfoCheck: false,
        employeeDetailInfoCheck:true,
        contactInfoCheck: false,
        educationInfoCheck: false,
        familyDetailCheck: false,
        skillInfoCheck: false,
        workHistoryInfoCheck: false
      };
    case actionTypes.CHECK_CONTACT_INFO_CHANGE:
      return {
        ...state,
        personalInfoCheck: false,
        employeeDetailInfoCheck:false,
        contactInfoCheck: true,
        educationInfoCheck: false,
        familyDetailCheck: false,
        skillInfoCheck: false,
        workHistoryInfoCheck: false
      };
    case actionTypes.CHECK_EDUCATION_INFO_CHANGE:
      return {
        ...state,
        personalInfoCheck: false,
        employeeDetailInfoCheck:false,
        contactInfoCheck: false,
        educationInfoCheck: true,
        familyDetailCheck: false,
        skillInfoCheck: false,
        workHistoryInfoCheck: false
      };
    case actionTypes.CHECK_FAMILY_INFO_CHANGE:
      return {
        ...state,
        personalInfoCheck: false,
        employeeDetailInfoCheck:false,
        contactInfoCheck: false,
        educationInfoCheck: false,
        familyDetailCheck: true,
        skillInfoCheck: false,
        workHistoryInfoCheck: false
      };
    case actionTypes.CHECK_SKILL_INFO_CHANGE:
      return {
        ...state,
        personalInfoCheck: false,
        employeeDetailInfoCheck:false,
        contactInfoCheck: false,
        educationInfoCheck: false,
        familyDetailCheck: false,
        skillInfoCheck: true,
        workHistoryInfoCheck: false
      };
    case actionTypes.CHECK_WORK_HISTORY_CHANGE:
      return {
        ...state,
        personalInfoCheck: false,
        employeeDetailInfoCheck:false,
        contactInfoCheck: false,
        educationInfoCheck: false,
        familyDetailCheck: false,
        skillInfoCheck: false,
        workHistoryInfoCheck: true
      };
    case actionTypes.CLEAR_CHANGE_WIZARD:
      return {
        ...state,
        personalInfoCheck: false,
        employeeDetailInfoCheck:false,
        contactInfoCheck: false,
        educationInfoCheck: false,
        familyDetailCheck: false,
        skillInfoCheck: false,
        workHistoryInfoCheck: false
      };
    case actionTypes.LOADING_SHOW:
      return {
        ...state,
        Loading: true
      };
    case actionTypes.LOADING_HIDE:
      return {
        ...state,
        Loading: false
      };
    case actionTypes.IS_VALID_FORM:
      return { ...state, isValidForm: action.isValid };
    case actionTypes.SET_PERSONAL_INFO_ERRORS:
      return {
        ...state,
        personalInfoErrors: action.objErrors
      };
      case actionTypes.SET_EMP_DETAIL_ERRORS:
      return {
        ...state,
        employeeDetailErrors: action.objErrors
      };
    case actionTypes.SET_CONTACT_INFO_ERRORS:
      return {
        ...state,
        contactInfoErrors: action.objErrors
      };
    case actionTypes.SET_WORKHISTORY_INFO_ERRORS:
      return {
        ...state,
        workHistoryInfoErrors: action.objErrors
      };
    case actionTypes.SET_EDUCATION_INFO_ERRORS:
      return {
        ...state,
        educationInfoErrors: action.objErrors
      };
    case actionTypes.SET_FAMILY_INFO_ERRORS:
      return {
        ...state,
        familyDetailErrors: action.objErrors
      };
    case actionTypes.SET_SKILL_INFO_ERRORS:
      return {
        ...state,
        skillInfoErrors: action.objErrors
      };
    case actionTypes.SET_OTHER_INFO_ERRORS:
      return {
        ...state,
        otherInfoErrors: action.objErrors
      };
    case actionTypes.CLEAR_EDUCATION_ERROR:
      return {
        ...state,
        educationInfoErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.educationInfoErrors
        }
      };
    case actionTypes.CLEAR_FAMILY_ERROR:
      return {
        ...state,
        familyDetailErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.familyDetailErrors
        }
      };
    case actionTypes.CLEAR_SKILL_ERROR:
      return {
        ...state,
        skillInfoErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.skillInfoErrors
        }
      };
    case actionTypes.CLEAR_WORK_HISTORY_ERROR:
      return {
        ...state,
        workHistoryInfoErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.workHistoryInfoErrors
        }
      };
    case actionTypes.CLEAR_ERROR_OBJECT:
      return {
        ...state,
        workHistoryInfoErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.workHistoryInfoErrors
        },
        skillInfoErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.skillInfoErrors
        },
        familyDetailErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.familyDetailErrors
        },
        educationInfoErrors: {
          ...State.INITIAL_STATE.DefaultErrorState.educationInfoErrors
        }
      };
    case actionTypes.SET_FILE_DETAIL:
      return {
        ...state,
        File: action.file
      };
    case actionTypes.CLEAR_FILE_DETAIL:
      return {
        ...state,
        File: ""
      };
    case actionTypes.PROFILE_IMAGE_SAVE_BTN:
      return {
        ...state,
        ProfileImageSaveBtn: action.value
      };
    case actionTypes.BULK_UPLOAD:
      return {
        ...state,
        addNewEmployeeView: false,
        employeesListView: false,
        employeeDetailView: false
      };
    case actionTypes.SHOW_BULK_ERROR:
      return {
        ...state,
        Errors: action.payload.data,
        Message: "File Failed to Upload"
      };
    case actionTypes.SHOW_BULK_SUCCESS:
      return {
        ...state,
        Message: action.payload
      };
    default:
      return {
        ...state
      };
  }
}
